import { BaseSelectFilter } from '../../types/common/filters';
import { ACTION_TYPE_LABELS, ENTITY_TYPE_LABELS, STATUS_LABELS } from '../../types/api/logs';

const ADMIN_ACTIONS = new Set(['admin_login', 'logout', 'create', 'update', 'delete', 'moderate', 'export']);
export interface LogFilters { logActionType?: string; logEntityType?: string; logStatus?: string; }

export const logsFilterConfig = (users: boolean): BaseSelectFilter[] => [
    { key: 'logActionType', label: 'Тип действия', options: Object.entries(ACTION_TYPE_LABELS)
        .filter(([value]) => users !== ADMIN_ACTIONS.has(value)).map(([value, label]) => ({ value, label })) },
    { key: 'logEntityType', label: 'Объект действия', options: Object.entries(ENTITY_TYPE_LABELS)
        .filter(([value]) => value !== 'seller').map(([value, label]) => ({ value, label })) },
    { key: 'logStatus', label: 'Статус', options: Object.entries(STATUS_LABELS).map(([value, label]) => ({ value, label })) },
];
